import ImageGalleryTab from "./imageGalleryTab.container";

export default ImageGalleryTab;
